import type { ElementType } from 'react';
import { Car, Heart, Settings, Book, Fuel, Dumbbell, Calculator, GalleryHorizontal, ClipboardList, Briefcase, FileText, BarChart3, CheckSquare, Phone, Sparkles } from 'lucide-react';

export interface AppRoute {
  id: string;
  title: string;
  path: string;
  icon: ElementType;
  description?: string;
  children?: AppRoute[];
}

export const appRoutes: AppRoute[] = [
  {
    id: 'car',
    title: 'Car',
    path: '/car',
    icon: Car,
    description: 'Track fuel, maintenance, and expenses',
    children: [
      { id: 'service-book', title: 'Service Book', path: '/car/service-book', icon: Book },
      { id: 'car-fuel', title: 'Fuel Tracking', path: '/car/fuel', icon: Fuel },
      { id: 'car-gallery', title: 'Car Gallery', path: '/car/gallery', icon: GalleryHorizontal },
      { id: 'car-trip-cost', title: 'Trip Cost Calculator', path: '/car/trip-cost-calculator', icon: Calculator },
      { id: 'car-contacts', title: 'Car Contacts', path: '/car/contacts', icon: Phone },
    ]
  },
  {
    id: 'gym',
    title: 'Gym',
    path: '/gym',
    icon: Dumbbell,
    description: 'Track your workouts and progress',
    children: [
      {
        id: 'my-training-plan',
        title: 'My Training Plan',
        path: '/gym/my-training-plan',
        icon: ClipboardList,
      },
      {
        id: 'workout-wheel',
        title: 'Workout Wheel',
        path: '/gym/workout-wheel',
        icon: Sparkles,
      },
    ]
  },
  {
    id: 'job',
    title: 'Job',
    path: '/job',
    icon: Briefcase,
    description: 'Job hunting and application tracking',
    children: [
      { id: 'job-tracker', title: 'Application Tracker', path: '/job/tracker', icon: ClipboardList },
      { id: 'job-cv', title: 'CV Manager', path: '/job/cv-manager', icon: FileText },
      { id: 'job-dashboard', title: 'Dashboard', path: '/job/dashboard', icon: BarChart3 },
    ]
  },
  {
    id: 'health',
    title: 'Health',
    path: '/health',
    icon: Heart,
    description: 'Health tools',
  },
  {
    id: 'todo',
    title: 'Todo',
    path: '/todo',
    icon: CheckSquare,
    description: 'Simple personal task list',
  },
  {
    id: 'settings',
    title: 'Settings',
    path: '/settings',
    icon: Settings,
    description: '',
  },
]; 